export default __webpack_public_path__ + "static/media/splash-image-02.bb6a4bf1.png";